import React, { Dispatch, FC, SetStateAction } from "react";
import PippaProvider from "./provider/pippa";
import Pippa from "@app/pippa/components/pippa";
import { PippaIngressSource } from "@app/pippa/models/analytics";

interface PippaWidgetProps {
  isWidgetOpen: boolean;
  setIsWidgetOpen: Dispatch<SetStateAction<boolean>>;
  ingressSource?: PippaIngressSource;
}

const PippaWidget: FC<PippaWidgetProps> = ({
  isWidgetOpen,
  setIsWidgetOpen,
  ingressSource,
}) => {
  return (
    <PippaProvider
      isWidgetOpen={isWidgetOpen}
      setIsWidgetOpen={setIsWidgetOpen}
      ingressSource={ingressSource}
    >
      <Pippa />
    </PippaProvider>
  );
};

export default PippaWidget;
